import { render, staticRenderFns } from "./TimeSettings.vue?vue&type=template&id=4f51cb08"
import script from "./TimeSettings.vue?vue&type=script&lang=js"
export * from "./TimeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports